// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1u6Ey","validationTips":"StatementDescriptor_validationTips__1HTOz"};